import { createRequest } from "helpers/tools";

export const sendAppsflyerData = async (data) => {
    return await createRequest({
        suffix: "appsflyer",
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const appsflyerMapping = async (data, id) => {
    return await createRequest({
        suffix: `appsflyer/update/${id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const getAppsflyerMapping = async (id) => {
    return await createRequest({
        suffix: `appsflyer/${id}/fields`,
        method: "get",
        handleError: false,
    });
};

export const getAppsflyerTest = async (id) => {
    return await createRequest({
        suffix: `appsflyer/${id}/preview`,
        method: "get",
        handleError: false,
    });
};
